import React from 'react';
import ReactDOM from 'react-dom';
import axios from "axios";

import { Grid, Box, MenuItem, MenuList, ClickAwayListener, Link} from '@material-ui/core';
import DehazeIcon from '@material-ui/icons/Dehaze';
import CloseIcon from '@material-ui/icons/Close';
import landinvestlogo from "../images/logos/landinvest.svg";

import CabinetContent from './CabinetContent.js';

export default function Header(){

        var state = { user:{}, ProfileName:'', CabinetType: '' }

        const [openProfileMenu, setOpenProfileMenu] = React.useState(false);
        const [switcherMenu,setSwitcherMenu] = React.useState({openSwitcher:false});
        const [userValues, setUserValues] = React.useState({currentCabinetTxt:'Кабінет продавця', currentCabinetTypeVal:"Seller", typecabinet:{Investor:'Investor',Seller:'Seller',cabinetInvestor:"Кабінет інвестора", cabinetSeller:"Кабінет продавця"}, SavedFieldsCount:0 });

        const handleProfileMenuClick = () => {
            if(openProfileMenu == true){
                setOpenProfileMenu(false);
            }else if(openProfileMenu == false){
                setOpenProfileMenu(true);
            }
        };
    
        const handleProfileMenuClickAway = () => {
            setOpenProfileMenu(false);
        };

        function handleSiteSwitcherClick(){
            if(switcherMenu.openSwitcher == true){
                setSwitcherMenu({openSwitcher:false});
            }else if(switcherMenu.openSwitcher == false){
                setSwitcherMenu({openSwitcher:true});
            }

            
        };

        function handleSiteSwitcherClickAway () {
            setSwitcherMenu({openSwitcher:false});

        };

        const [openMobileMenu, setOpenMobileMenu] = React.useState(false);
        const handleClickMobileMenu = () => {setOpenMobileMenu(!openMobileMenu); handleSiteSwitcherClickAway(); };

        function ChangePageSeller(page){

            if(state.user.PhoneNumber) {
                if(page == "MyFields"){

                    resetMenuStylesSeller();
        
                    document.getElementById("menu-item-myfield").setAttribute("class","active");
        
                    ReactDOM.render((<CabinetContent  page="MyFields" user={state.user} cabinettype={state.CabinetType} />), document.getElementById('contentHtml'));
        
                } else if(page == "MyDocuments"){
                    resetMenuStylesSeller();
        
                    document.getElementById("menu-item-mydocuments").setAttribute("class","active");
        
                    ReactDOM.render((<CabinetContent page="MyDocuments" user={state.user} cabinettype={state.CabinetType} />), document.getElementById('contentHtml'));
                     
                }
            }

            if(page == "Settings"){
                resetMenuStylesSeller();
    
                document.getElementById("menu-item-settings-seller").setAttribute("class","active");
    
    
                ReactDOM.render((<CabinetContent page="Settings" user={state.user} cabinettype={state.CabinetType}  />), document.getElementById('contentHtml'));
            }

          
            handleProfileMenuClickAway();
        }

        function ChangePageInvestor(page){

            if(state.user.PhoneNumber) {

                if(page == "MyRequestes") {
                    resetMenuStylesInvestor();

                    document.getElementById("menu-item-myrequestes-investor").setAttribute("class","active");

                    ReactDOM.render((<CabinetContent page="MyRequestes" user={state.user} cabinettype={state.CabinetType}   />), document.getElementById('contentHtml'));

                }
                else if(page == "RecommendedFields"){
                    resetMenuStylesInvestor();
    
                    document.getElementById("menu-item-recommendedfields-investor").setAttribute("class","active");
    
                    ReactDOM.render((<CabinetContent page="RecommendedFields" user={state.user} cabinettype={state.CabinetType}  />), document.getElementById('contentHtml'));
                }else if(page == "SavedFields"){
                    resetMenuStylesInvestor();
    
                    document.getElementById("menu-item-savedfields-investor").setAttribute("class","active");
    
                    ReactDOM.render((<CabinetContent page="SavedFields" user={state.user} cabinettype={state.CabinetType}  />), document.getElementById('contentHtml'));
                }
            }

            if(page == "Settings"){
    
                resetMenuStylesInvestor();
    
                document.getElementById("menu-item-settings-investor").setAttribute("class","active");
    
                ReactDOM.render((<CabinetContent page="Settings" user={state.user} cabinettype={state.CabinetType}  />), document.getElementById('contentHtml'));
            }
    

            handleProfileMenuClickAway();
        }


       function resetMenuStylesSeller(){
            document.getElementById("menu-item-myfield").setAttribute("class","unactive");
            document.getElementById("menu-item-mydocuments").setAttribute("class","unactive");
            document.getElementById("menu-item-settings-seller").setAttribute("class","unactive");
        }

        function resetMenuStylesInvestor(){
            document.getElementById("menu-item-myrequestes-investor").setAttribute("class","unactive");
            document.getElementById("menu-item-recommendedfields-investor").setAttribute("class","unactive");
            document.getElementById("menu-item-savedfields-investor").setAttribute("class","unactive");
            document.getElementById("menu-item-settings-investor").setAttribute("class","unactive");
        }

        function redirectToLogin(){
            window.location.href = '/login';
        }

        function LogOut(){
            axios
            .get("Account/Logout", { withCredentials: true })
            .then(response => {
                if(response.data == true){
                    redirectToLogin();
                }
            });
        }

        function handleCabinetSwitch(typecabinet){
            
            if(typecabinet == userValues.typecabinet.Investor){

                if(userValues.currentCabinetTypeVal != typecabinet){
                    axios.post('/Account/ChangeCabinet')
                    .then((response)=> {
                             
                        userValues.currentCabinetTxt = userValues.typecabinet.cabinetInvestor;
                        userValues.currentCabinetTypeVal = userValues.typecabinet.Investor;
    
                        window.location.reload();
    
                    })
                    .catch(function (error) {
    
                    });
                }
              

            }else if(typecabinet == userValues.typecabinet.Seller){


                if(userValues.currentCabinetTypeVal != typecabinet){
                    axios.post('/Account/ChangeCabinet')
                    .then((response)=> {
    
                        userValues.currentCabinetTxt = userValues.typecabinet.cabinetSeller;
                        userValues.currentCabinetTypeVal = userValues.typecabinet.Seller;
        
                        window.location.reload();
    
                    })
                    .catch(function (error) {
    
                    });
                }else {
                  //  handleSiteSwitcherClickAway();
                }
             
            }
        }

        CheckLoginStatus();

        function CheckLoginStatus(){
            axios
            .get("Account/CheckLogin", { withCredentials: true })
            .then(response => {

                if(response.data.IsAuthenticated == true){
                    axios
                    .get("Account/GetUserInfo", { withCredentials: true })
                    .then(response => {

                        state.user = response.data;
                        state.CabinetType = response.data.UserRole;

                        userValues.currentCabinetTypeVal = state.CabinetType;               
                        userValues.SavedFieldsCount = response.data.SavedFieldsCount;

                        if(userValues.currentCabinetTypeVal == userValues.typecabinet.Seller){
                            userValues.currentCabinetTxt = userValues.typecabinet.cabinetSeller;
                        }else if(userValues.currentCabinetTypeVal == userValues.typecabinet.Investor){
                            userValues.currentCabinetTxt = userValues.typecabinet.cabinetInvestor; 
                        }

                        if(response.data.FIO != '' && response.data.FIO != null){
                            state.ProfileName = response.data.FIO.split(" ")[0];
                        }else if(response.data.CompanyName != '' && response.data.CompanyName != null){
                            
                            var MaxLengthStringShow = 10;

                            if(window.screen.width > 973){
                                MaxLengthStringShow = 10;
                            }

                            if(window.screen.width < 973){
                                MaxLengthStringShow = 40;
                            }

                            if(window.screen.width < 600){
                                MaxLengthStringShow = 35;
                            }

                            if(window.screen.width < 500){
                                MaxLengthStringShow = 30;
                            }

                            if(window.screen.width < 400) {
                                MaxLengthStringShow = 25;
                            }

                            if(window.screen.width < 300) {
                                MaxLengthStringShow = 20;
                            }

                            if(response.data.CompanyName.length > MaxLengthStringShow){
                                state.ProfileName = response.data.CompanyName.substring(0,MaxLengthStringShow) + "...";
                            }else {
                                state.ProfileName = response.data.CompanyName;
                            }

                           
                        }

                    const element1=(
                        <Grid>
                            <Grid container className="header">
                                <Grid container item  wrap="nowrap" className="titlelogo" >
                                    <Box className="logo">
                                        <img src={landinvestlogo} />
                                    </Box>
                                </Grid>
                                <Grid container item wrap="nowrap" className="Mob-Icon" onClick={handleClickMobileMenu}>
                                    { openMobileMenu ? <CloseIcon /> : <DehazeIcon /> }
                                </Grid>
                                <div className={openMobileMenu ? 'MobMenu active' : 'MobMenu'}>

                                {userValues.currentCabinetTypeVal == userValues.typecabinet.Seller ?

                                    <Grid container item direction="row" justify="flex-end" alignItems="baseline" className="menu" >
                                                                    
                                    <Box className="addfield">
                                        <Box >
                                            <Box component="span" className="plus">
                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M8.82414 0.582754L7.17586 0.582755L7.17586 7.17586H0.582754V8.82414H7.17586L7.17586 15.4172H8.82414V8.82414H15.4172V7.17586L8.82414 7.17586V0.582754Z" fill="#3867B1" />
                                                    <path d="M9.40689 0V6.59311L16 6.59311V9.40689H9.40689V16H6.59311L6.59311 9.40689H0V6.59311H6.59311L6.59311 8.10479e-07L9.40689 0ZM7.17586 0.582755L8.82414 0.582754V7.17586L15.4172 7.17586V8.82414H8.82414V15.4172H7.17586L7.17586 8.82414H0.582754V7.17586H7.17586L7.17586 0.582755Z" fill="#3867B1" />
                                                </svg>
                                            </Box>
                                            <Box component="span" className="text" >
                                            <Link target="_blank" href="https://land-invest.com.ua/">Додати ділянку</Link> 
                                            </Box>
                                        </Box>
                                    </Box>


                                    <Box className="listitems">
                                    <Box className="item">
                                    <Link target="_blank" href="https://land-invest.com.ua/">Про нас</Link> 
                                    </Box>
                                    {
                                        /*
                                        
                                        <Box className="item">
                                        Купити
                                    </Box>
                                    <Box className="item">
                                        Ціни
                                    </Box>
                                    <Box className="item">
                                        Контакти
                                    </Box>

                                        */
                                    }
                                    </Box>
                                    </Grid>

                                    :
                                    null
                                }
                                {userValues.currentCabinetTypeVal == userValues.typecabinet.Investor ?
                                     <Grid container item direction="row" justify="flex-end" alignItems="center"  className="menu">

                                    

                                     <Box className="listitems">
                                        <Box className="item" >
                                        <Link target="_blank" href="https://land-invest.com.ua/">Про нас</Link> 
                                        </Box>
                                        {
                                            /*
                                            
                                            <Box className="item">
                                            Купити
                                        </Box>
                                        <Box className="item">
                                            Ціни
                                        </Box>
                                        <Box className="item">
                                            Контакти
                                        </Box>
    
                                            */
                                        }
                                        </Box>
                                     </Grid>   
                                    :
                                    null
                                }
                                
                                    <Grid container item justify="flex-end" alignItems="center" className="profile">
                                  
                                        <Box className="logo logo--Wibe">
                                            <Box component="span" className="txt" >Ми у </Box>
                                            <a href="https://chats.viber.com/landinvest" target="_blank">
                                                <svg width="24" height="26" viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M14.56 0.200195H9.43998C4.49918 0.200195 0.47998 4.2194 0.47998 9.1602V13.0002C0.47998 16.4722 2.47998 19.6178 5.59998 21.0994V25.3778C5.59998 25.749 6.06398 25.941 6.32638 25.6786L10.0448 21.9634H14.56C19.5008 21.9634 23.52 17.9442 23.52 13.0002V9.1602C23.52 4.2194 19.5008 0.200195 14.56 0.200195ZM17.9136 16.9941L16.6176 18.2613C15.2544 19.5957 11.696 18.0725 8.55998 14.8693C5.42398 11.6629 4.04798 8.07252 5.34398 6.73812L6.63998 5.47092C7.11678 5.00372 7.92638 5.01332 8.46078 5.49012L10.3296 7.40052C10.9952 8.08212 10.7136 9.22451 9.83358 9.48691C9.22558 9.68211 8.81278 10.3509 9.00798 10.9589C9.33118 12.3797 11.1328 14.1557 12.4768 14.5077C13.0816 14.6485 13.76 14.3189 13.9712 13.7141C14.2496 12.8405 15.3984 12.5813 16.0672 13.2661L17.9328 15.1733C18.4 15.6498 18.3936 16.4597 17.9136 16.9941ZM13.1648 6.2802C13.0368 6.2802 12.9088 6.28659 12.784 6.3026C12.5504 6.3282 12.3392 6.1586 12.3136 5.92499C12.288 5.69139 12.4576 5.4802 12.6912 5.4546C12.848 5.4354 13.008 5.429 13.1648 5.429C15.5168 5.429 17.4304 7.34259 17.4304 9.69459C17.4304 9.85139 17.424 10.0114 17.4048 10.1682C17.3792 10.3986 17.1648 10.5714 16.9344 10.5458C16.704 10.5202 16.5312 10.3058 16.5568 10.0754C16.5696 9.95059 16.5792 9.82259 16.5792 9.69459C16.5792 7.81299 15.0464 6.2802 13.1648 6.2802ZM15.7248 9.69459C15.7248 9.92819 15.5296 10.1202 15.296 10.1202C15.0656 10.1202 14.8704 9.92819 14.8704 9.69459C14.8704 8.75379 14.1056 7.989 13.1648 7.989C12.928 7.989 12.736 7.797 12.736 7.56019C12.736 7.3266 12.928 7.1346 13.1648 7.1346C14.576 7.1346 15.7248 8.28339 15.7248 9.69459ZM18.9792 11.0738C18.9248 11.3042 18.6784 11.4482 18.4512 11.3874C18.2304 11.3266 18.096 11.0962 18.1472 10.8754C18.24 10.4914 18.2848 10.0946 18.2848 9.69459C18.2848 6.87219 15.9872 4.5746 13.1648 4.5746C13.0336 4.5746 12.8992 4.5778 12.768 4.59059C12.5344 4.6066 12.3296 4.43059 12.3104 4.197C12.2944 3.9602 12.4704 3.7554 12.704 3.7394C12.8576 3.7266 13.0112 3.7202 13.1648 3.7202C16.4576 3.7202 19.1392 6.40179 19.1392 9.69459C19.1392 10.1586 19.0848 10.6226 18.9792 11.0738Z" fill="white" />
                                                </svg>
                                            </a>
                                        </Box>
                                        <ClickAwayListener onClickAway={()=> handleSiteSwitcherClickAway()}>
                                            <Box className="logo logo--Menu" onClick={()=>handleSiteSwitcherClick()} >

                                                {
                                                    userValues.currentCabinetTypeVal == userValues.typecabinet.Seller ? 
                                                    <Box>
                                                        <svg className="menuicon" width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <g clipPath="url(#clip0)">
                                                        <path d="M10.3125 0.638522V1.92758C10.3125 2.77725 11.6016 2.78073 11.6016 1.92758V0.638522C11.6016 -0.211099 10.3125 -0.21458 10.3125 0.638522Z" fill="white"/>
                                                        <path d="M19.9808 9.10938H18.6917C17.8421 9.10938 17.8386 10.3984 18.6917 10.3984H19.9808C20.8304 10.3984 20.8339 9.10938 19.9808 9.10938Z" fill="white"/>
                                                        <path d="M3.22299 9.10938H1.93393C1.08431 9.10938 1.08083 10.3984 1.93393 10.3984H3.22299C4.07262 10.3984 4.0761 9.10938 3.22299 9.10938Z" fill="white"/>
                                                        <path d="M18.4488 4.59216L17.3328 5.23669C16.6021 5.65864 17.234 6.78266 17.9773 6.35328L19.0933 5.70875C19.8349 5.28043 19.1792 4.16553 18.4488 4.59216Z" fill="white"/>
                                                        <path d="M14.9101 1.52518L14.2655 2.64116C14.0167 3.07188 14.3298 3.60796 14.8232 3.60796C15.046 3.60796 15.2625 3.49276 15.3821 3.28569L16.0267 2.16971C16.4535 1.43069 15.3334 0.788133 14.9101 1.52518Z" fill="white"/>
                                                        <path d="M7.6483 2.64158L7.00377 1.52559C6.57331 0.783993 5.46356 1.43665 5.88719 2.17012L6.53172 3.28611C6.9587 4.02547 8.07709 3.38399 7.6483 2.64158Z" fill="white"/>
                                                        <path d="M4.58111 5.23651L3.46513 4.59198C2.73406 4.1659 2.07883 5.28017 2.82059 5.70857L3.93658 6.3531C4.67513 6.7797 5.31665 5.6613 4.58111 5.23651Z" fill="white"/>
                                                        <path d="M10.957 3.86133C7.7602 3.86133 5.15625 6.55714 5.15625 9.75406C5.15625 9.97316 5.16914 10.1923 5.20777 10.3986H16.7063C16.7449 10.1923 16.7578 9.97316 16.7578 9.75406C16.7578 6.55714 14.1539 3.86133 10.957 3.86133Z" fill="white"/>
                                                        <path d="M15.0887 11.6875H14.1074L17.0537 22H20.9814L15.0887 11.6875Z" fill="white"/>
                                                        <path d="M6.91114 11.6875L1.01807 22H4.94554L7.89225 11.6875H6.91114Z" fill="white"/>
                                                        <path d="M21.3557 11.6875H16.5737L22.0003 21.184V12.332C22.0003 11.9711 21.7167 11.6875 21.3557 11.6875Z" fill="white"/>
                                                        <path d="M9.23338 11.6875L6.28662 22H10.3123V11.6875H9.23338Z" fill="white"/>
                                                        <path d="M0.644531 11.6875C0.283551 11.6875 0 11.9711 0 12.332V21.1843L5.42691 11.6875H0.644531Z" fill="white"/>
                                                        <path d="M12.7667 11.6875H11.6016V22H15.7129L12.7667 11.6875Z" fill="white"/>
                                                        </g>
                                                        <defs>
                                                        <clipPath id="clip0">
                                                        <rect width="22" height="22" rx="8" fill="white"/>
                                                        </clipPath>
                                                        </defs>
                                                        </svg>
                                                        <Box component="span" className="txt" >{userValues.typecabinet.cabinetSeller}</Box>

                                                        { switcherMenu.openSwitcher == false ?(
                                                            <svg className="dropsymbol-closedSwitcher" width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M13 1.6665L7 7.6665L1 1.6665" stroke="white" strokeWidth={openMobileMenu ? 0: 2} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                                                            </svg>
                                                        ):null}


                                                        { switcherMenu.openSwitcher == true ?(
                                                            <svg className="dropsymbol-openSwitcher" width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M13 1.6665L7 7.6665L1 1.6665" stroke="white" strokeWidth={openMobileMenu ? 0: 2} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                                                            </svg>
                                                        ):null}

                                                    </Box>
                                                    : null
                                                }
                    
                                                {
                                                    userValues.currentCabinetTypeVal == userValues.typecabinet.Investor ?
                                                    <Box>
                                                        <svg className="menuicon" width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M20.4853 3.51469C18.2188 1.24819 15.2053 0 12 0C8.79469 0 5.78119 1.24819 3.51469 3.51469C1.24819 5.78119 0 8.79469 0 12C0 15.2053 1.24823 18.2188 3.51469 20.4853C5.78114 22.7519 8.79469 24 12 24C15.2053 24 18.2188 22.7518 20.4853 20.4853C22.7518 18.2188 24 15.2053 24 12C24 8.79469 22.7518 5.78123 20.4853 3.51469ZM12 11.25C13.861 11.25 15.375 12.764 15.375 14.625C15.375 16.1661 14.3364 17.4684 12.9226 17.8708C12.821 17.8997 12.75 17.991 12.75 18.0967V18.7288C12.75 19.1327 12.4396 19.4802 12.0362 19.4992C11.6055 19.5194 11.25 19.1762 11.25 18.75V18.0965C11.25 17.9912 11.1794 17.8998 11.0781 17.871C9.67036 17.4706 8.63442 16.1782 8.62505 14.646C8.62256 14.237 8.94413 13.887 9.35297 13.8753C9.77723 13.8631 10.125 14.2035 10.125 14.625C10.125 15.7032 11.0399 16.5718 12.134 16.4953C13.0576 16.4308 13.8058 15.6825 13.8703 14.7589C13.9467 13.6647 13.0782 12.75 12 12.75C10.139 12.75 8.625 11.236 8.625 9.375C8.625 7.83389 9.66361 6.53161 11.0774 6.12923C11.179 6.10031 11.25 6.00895 11.25 5.90334V5.27119C11.25 4.86731 11.5604 4.51983 11.9638 4.50084C12.3945 4.48059 12.75 4.82377 12.75 5.25V5.90348C12.75 6.00881 12.8206 6.10022 12.9219 6.12905C14.3296 6.52936 15.3656 7.82184 15.375 9.35405C15.3774 9.76303 15.0559 10.113 14.647 10.1247C14.2228 10.1369 13.875 9.79655 13.875 9.375C13.875 8.29678 12.9601 7.42819 11.866 7.50469C10.9424 7.56923 10.1942 8.31745 10.1297 9.24108C10.0533 10.3353 10.9218 11.25 12 11.25Z" fill="white"/>
                                                        </svg>
                                                        <Box component="span" className="txt" >{userValues.typecabinet.cabinetInvestor}</Box>

                                                        { switcherMenu.openSwitcher == false ?(
                                                            <svg className="dropsymbol-closedSwitcher" width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M13 1.6665L7 7.6665L1 1.6665" stroke="white" strokeWidth={openMobileMenu ? 0: 2} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                                                    </svg>
                                                        ):null}


                                                        { switcherMenu.openSwitcher == true ?(
                                                            <svg className="dropsymbol-openSwitcher" width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M13 1.6665L7 7.6665L1 1.6665" stroke="white" strokeWidth={openMobileMenu ? 0: 2} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                                                            </svg>
                                                        ):null}

                                                    </Box>

                                                    : null
                                                }                                 

                                                                    
                                            {
                                                    switcherMenu.openSwitcher ? (

                                                            <Grid className="dropdownmenu-switcher" >
                                                                {state.user.RelatedAccountRole == null? 
                                                                <MenuList>
                                                                    <MenuItem onClick={() => handleSiteSwitcherClickAway()} ><Box component="span" className="title"  >{userValues.currentCabinetTxt}</Box></MenuItem>
                                                                </MenuList>
                                                                    :
                                                                    null
                                                                }

                                                                {state.user.RelatedAccountRole != null ?
                                                                    <MenuList>
                                                                        <MenuItem onClick={() => handleCabinetSwitch(userValues.typecabinet.Investor)}><Box component="span" className="title"  >{userValues.typecabinet.cabinetInvestor}</Box></MenuItem>
                                                                        <MenuItem onClick={() => handleCabinetSwitch(userValues.typecabinet.Seller)} ><Box component="span" className="title"  >{userValues.typecabinet.cabinetSeller}</Box></MenuItem>
                                                                    </MenuList>

                                                                    :
                                                                    null
                                                                }
                                                        
                                                            </Grid>
                                                    ) : null
                                                }
                                            
                                            
                                            </Box>

                                        </ClickAwayListener>
                                       
                                        <ClickAwayListener  onClickAway={handleProfileMenuClickAway}>
                                            <Box className="logo logo--Avatar" onClick={handleProfileMenuClick}>
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M12.008 12.8069C11.0587 12.8069 10.1306 12.5254 9.34127 11.998C8.55192 11.4705 7.93669 10.7209 7.57339 9.84381C7.21009 8.96674 7.11503 8.00163 7.30024 7.07054C7.48545 6.13945 7.9426 5.28418 8.6139 4.6129C9.28519 3.94162 10.1405 3.48447 11.0716 3.29926C12.0027 3.11406 12.9678 3.20911 13.8449 3.57241C14.722 3.9357 15.4716 4.55092 15.9991 5.34026C16.5265 6.12961 16.808 7.05762 16.808 8.00696C16.808 9.27998 16.3023 10.5009 15.4021 11.401C14.5019 12.3012 13.281 12.8069 12.008 12.8069ZM12.008 4.80701C11.3751 4.80701 10.7564 4.99468 10.2302 5.3463C9.70395 5.69791 9.29379 6.19768 9.05159 6.78239C8.80939 7.36711 8.74602 8.01051 8.8695 8.63124C8.99297 9.25197 9.29774 9.82214 9.74527 10.2697C10.1928 10.7172 10.763 11.022 11.3837 11.1454C12.0045 11.2689 12.6479 11.2055 13.2326 10.9633C13.8173 10.7211 14.3171 10.311 14.6687 9.78476C15.0203 9.25853 15.208 8.63985 15.208 8.00696C15.208 7.15828 14.8709 6.34436 14.2707 5.74425C13.6706 5.14415 12.8567 4.80701 12.008 4.80701Z" fill="white" />
                                                    <path d="M12.0078 24.0074C10.2338 24.0062 8.48206 23.6117 6.87878 22.8523C5.27551 22.0928 3.86057 20.9874 2.73582 19.6155L2.31982 19.1035L2.73582 18.5995C3.86152 17.2294 5.27688 16.1257 6.8801 15.368C8.48332 14.6103 10.2345 14.2173 12.0078 14.2173C13.7811 14.2173 15.5323 14.6103 17.1355 15.368C18.7388 16.1257 20.1541 17.2294 21.2798 18.5995L21.6958 19.1035L21.2798 19.6155C20.1551 20.9874 18.7401 22.0928 17.1369 22.8523C15.5336 23.6117 13.7819 24.0062 12.0078 24.0074ZM4.41582 19.1115C5.38881 20.1531 6.56553 20.9835 7.87292 21.5513C9.1803 22.1191 10.5905 22.4121 12.0158 22.4121C13.4412 22.4121 14.8513 22.1191 16.1587 21.5513C17.4661 20.9835 18.6428 20.1531 19.6158 19.1115C18.6428 18.0699 17.4661 17.2394 16.1587 16.6716C14.8513 16.1038 13.4412 15.8108 12.0158 15.8108C10.5905 15.8108 9.1803 16.1038 7.87292 16.6716C6.56553 17.2394 5.38881 18.0699 4.41582 19.1115Z" fill="white" />
                                                    <path d="M12.008 24.007C9.2822 24.0088 6.637 23.0826 4.50776 21.3807C2.37852 19.6789 0.892133 17.3028 0.293238 14.6437C-0.305657 11.9845 0.0186293 9.2007 1.21272 6.75039C2.40682 4.30009 4.39956 2.32933 6.86297 1.16246C9.32639 -0.00439903 12.1137 -0.297826 14.7661 0.330478C17.4185 0.958782 19.7779 2.47137 21.4561 4.6193C23.1343 6.76723 24.0312 9.42249 23.9992 12.1481C23.9672 14.8736 23.0082 17.5071 21.28 19.615C20.1553 20.987 18.7403 22.0924 17.137 22.8519C15.5338 23.6113 13.7821 24.0058 12.008 24.007ZM12.008 1.60731C9.95108 1.60731 7.94035 2.21725 6.23008 3.36C4.51981 4.50275 3.18681 6.12698 2.39966 8.02731C1.61251 9.92763 1.40656 12.0187 1.80784 14.0361C2.20913 16.0534 3.19963 17.9065 4.6541 19.361C6.10856 20.8154 7.96167 21.8059 9.97907 22.2072C11.9965 22.6085 14.0876 22.4025 15.9879 21.6154C17.8883 20.8282 19.5125 19.4952 20.6553 17.785C21.798 16.0748 22.408 14.0641 22.408 12.0072C22.408 9.24895 21.3123 6.6037 19.3619 4.65335C17.4115 2.703 14.7663 1.60731 12.008 1.60731Z" fill="white" />
                                                    <path d="M3.35205 19.1105C3.35205 19.1105 11.408 28.1103 19.608 20.0065L20.664 19.1105C20.664 19.1105 13.816 12.0066 6.86405 16.2705L3.35205 19.1105Z" fill="white" />
                                                    <path d="M12.0083 12.0077C14.2174 12.0077 16.0083 10.2169 16.0083 8.00775C16.0083 5.79865 14.2174 4.00781 12.0083 4.00781C9.79916 4.00781 8.0083 5.79865 8.0083 8.00775C8.0083 10.2169 9.79916 12.0077 12.0083 12.0077Z" fill="white" />
                                                </svg>
                                                <Box className="name" title={state.user.FIO != '' && state.user.FIO != null ? state.user.FIO : state.user.CompanyName}>
                                                    {state.ProfileName}
                                                </Box>

                                            
                                            </Box>
                                        </ClickAwayListener>

                                        {
                                            openProfileMenu ? (

                                                    <Grid className="dropdownmenu-profile" >
                                                        {userValues.currentCabinetTypeVal == userValues.typecabinet.Seller ?
                                                        <MenuList>                               
                                                            <MenuItem onClick={() => ChangePageSeller("MyFields")} ><Box component="span" className="title"  >Мої ділянки</Box></MenuItem>
                                                            <MenuItem onClick={() => ChangePageSeller("MyDocuments")}><Box component="span" className="title"  >Мої документи</Box></MenuItem>
                                                            {/* <MenuItem ><Box component="span" className="title">Повідомлення (4)</Box></MenuItem> */}
                                                            <MenuItem onClick={() => ChangePageSeller("Settings")} ><Box component="span" className="title" >Налаштування</Box></MenuItem>
                                                            <MenuItem onClick={() => LogOut()} ><Box component="span" className="title" >Вийти</Box></MenuItem>
                                                    </MenuList>
                                                        :
                                                        null
                                                        }
                                                        
                                                        {userValues.currentCabinetTypeVal == userValues.typecabinet.Investor ?
                                                            <MenuList>                               
                                                                <MenuItem  onClick={() => ChangePageInvestor("MyRequestes")} ><Box component="span" className="title" >Мої ділянки</Box></MenuItem>
                                                                <MenuItem  onClick={() => ChangePageInvestor("RecommendedFields")} ><Box component="span" className="title" >Рекомендовані ділянки</Box></MenuItem>
                                                                <MenuItem  onClick={() => ChangePageInvestor("SavedFields")}  ><Box component="span" className="title" >Збережені ділянки (<Box component="span">{userValues.SavedFieldsCount}</Box>)</Box></MenuItem>
                                                                <MenuItem onClick={() => ChangePageInvestor("Settings")} ><Box component="span" className="title" >Налаштування</Box></MenuItem>
                                                            <MenuItem onClick={() => LogOut()} ><Box component="span" className="title" >Вийти</Box></MenuItem>
                                                    </MenuList>
                                                        :
                                                        null
                                                        }

                                                    </Grid>
                                            ) : null
                                        }  

                                    </Grid>
                                
                                </div>
                           
                            </Grid>
                        </Grid>
                        )

                        ReactDOM.render(element1, document.getElementById('headercontent'));
                    })
                }
            })
        }

    return (
       <Grid id="headercontent">

       </Grid>
    );
 
   
}

